import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore } from 'redux';
import orderStoreReducer from './store/orderStore';
import { Provider } from 'react-redux';
import AuthContextProvider from './context/auth-context';


const orderStore = createStore(orderStoreReducer);

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <Provider store={orderStore}>
        <App />
      </Provider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
